import { lazyLoad } from "utils/loadable";

const LibraryPage = lazyLoad(
  () => import("./index"),
  (module) => module.LibraryPage,
  {
    fallback: (
      <div>
        <p>Loading....</p>
      </div>
    ),
  }
);

export default LibraryPage;
